
export class TaazeProductUrlCreator {
  private baseUrl: string;

  constructor(baseUrl='https://www.taaze.tw') {
    this.baseUrl = baseUrl;
  }

  private appendQueryParams(url: string, query?: Record<string, string | number | boolean | undefined>): string {
    if (!query) return url;
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(query)) {
      if (value !== undefined) {
        searchParams.set(key, String(value));
      }
    }
    const queryString = searchParams.toString();
    return queryString ? `${url}?${queryString}` : url;
  }

  createProductUrl(productId: string, query?: Record<string, string>): string {
    const url = `${this.baseUrl}/products/${productId}.html`;
    return this.appendQueryParams(url, query);
  }

  createAddToCartUrl(productId: string, query?: Record<string, string>): string {
    const defaultParams = {
      pid: productId,
      oid: productId, 
    };
    const url = `${this.baseUrl}/ai_add2cart.html`;
    return this.appendQueryParams(url, { ...defaultParams, ...query });
  }
}